<template>
    <div class="no-padding no-margin">
        <!-- <Profile v-if="path == '/member/profile'"></Profile> -->
    </div>
</template>
<script>
    import Profile from "./Profile";
    export default {
        components:{
            Profile,
        },
        data(){
            return{

            }
        },
        computed:{
            path(){
               
                return this.$route.path
            },
            routeName(){
                return this.$route.params.name
            }
        },

        created(){

        },
        methods:{

        }

    }
</script>
<style>
    .background-opacity{
        opacity: 0.46;
        background-color: rgb(33, 33, 33);
        border-color: rgb(33, 33, 33);
    }
</style>